import { useQueryClient } from "@tanstack/react-query";
import { $journalApi } from "@entities/journal/fetch/fetch-client.ts";
import { useLocalUser } from "@shared/lib/hooks";
import {
  type TitleJournalMutateOptions,
  withTitleJournalInvalidation,
} from "./invalidate-title-journal-queries";

interface IUseRejectTitleJournal {
  titleId: string;
}

export function useRejectTitleJournal({ titleId }: IUseRejectTitleJournal) {
  const queryClient = useQueryClient();
  const user = useLocalUser();
  const { data: signers } = $journalApi.useQuery(
    "get",
    "/api/v1/journals/title/{titleId}/signs",
    {
      params: {
        path: { titleId },
      },
    },
  );
  const { data: responsibleList } = $journalApi.useQuery(
    "get",
    "/api/v1/journals/title/{titleId}/responsibleList/comments",
    {
      params: {
        path: { titleId },
      },
    },
  );

  const signerInfo = signers?.signers?.find(
    (signer) => user?.user_id === signer?.userInfo?.userId,
  );
  const approverInfo = responsibleList?.approvers?.find(
    (approver) => user?.user_id === approver.userHistory?.userId,
  );

  const isUserSigner = Boolean(signerInfo);
  const isUserApprover = Boolean(approverInfo);

  const approverMutation = $journalApi.useMutation(
    "post",
    "/api/v1/journals/title/{titleId}/status/reject/approve",
  );

  const signerMutation = $journalApi.useMutation(
    "post",
    "/api/v1/journals/title/{titleId}/sign/reject",
  );

  let mutation;
  if (isUserSigner && !isUserApprover) {
    mutation = signerMutation;
  } else {
    mutation = approverMutation;
  }

  return {
    ...mutation,
    mutate: (
      { comment }: { comment: string },
      mutateOptions?: TitleJournalMutateOptions,
    ) => {
      mutation.mutate(
        {
          params: {
            path: { titleId },
          },
          body: {
            comment,
            // @ts-expect-error tsc не понимает, что, если юзер не подписант - signer поле ему не нужно
            signer: isUserSigner
              ? {
                  representativeId: signerInfo?.representativeId,
                  constructionControlId: signerInfo?.constructionControlId,
                }
              : undefined,
          },
        },
        withTitleJournalInvalidation(queryClient, titleId, mutateOptions),
      );
    },
  };
}
